module.exports = __webpack_public_path__ + "static/other/ticket_taker.814a8a60.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/ticket_taker.json
// module id = 2601
// module chunks = 0